import React, { useEffect, useState, useRef } from "react";
import { cloneDeep } from "lodash";
import styled from "styled-components";
import playSound from "@/sound";
import {
  correctSound,
  incorrectSound,
  blockTouch,
  sleep,
  randomSort,
  touchSound,
} from "@stores/vars";
import TimeBar from "@components/TimeBar";
import anime from "animejs/lib/anime.es.js";
import CardGameScore from "@components/cardgame/CardGameScore";
import GameCompletePop from "@components/elements/GameCompletePop";
import CardGameWord from "@components/cardgame/CardGameWord";
import ReactCardFlip from "react-card-flip";
import { atom, useAtom } from "jotai";

const Wrap = styled.div`
  position: relative;
  height: 1200px;
  background: url(${require("@assets/img/cardgame/card_game_bg.png")}) no-repeat;
  z-index: 0;
`;
const TimeBarWrap = styled.div`
  position: absolute;
  left: 200px;
  top: 30px;
`;

const CardContainer = styled.div`
  position: relative;
  left: 50%;
  top: 270px;
  // background-color: #ff0000;
  transform: translateX(-50%);
  height: 800px;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  &.g-6 {
    width: 1400px;
  }
  &.g-8 {
    width: 1600px;
  }
  // &.g-10 {
  //   width: 1550px;
  // }
  // &.g-12 {
  //   width: 1820px;
  // }

  .ok {
    &:after {
      content: "";
      pointer-events: none;
      position: absolute;
      right: 25px;
      bottom: 20px;
      background: url(${require("@assets/img/correct.png")}) no-repeat;
      background-size: 50px 50px;
      background-position: center center;
      width: 50px;
      height: 50px;
      animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
  }
`;
const Card = styled.div`
  width: 362px;
  height: 262px;
  background: url(${require("@assets/img/cardgame/card_front.png")}) no-repeat;
  background-size: 100%;
  //margin: 20px 20px;
  position: relative;
  box-shadow: 8px 8px 0 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;

  &.back {
    background: url(${require("@assets/img/cardgame/card_back.png")}) no-repeat;
    background-size: 100%;
  }
  .img {
    // background: #ffee00;
    border-radius: 3px;
    width: calc(100% - 30px);
    height: calc(100% - 30px);
    left: 15px;
    top: 15px;
    position: absolute;
    align-items: center;
    justify-content: center;
    display: flex;
    > img {
      height: 100%;
    }
  }
`;

const HintButton = styled.button`
  background: url(${require("@assets/img/hint_button.png")}) no-repeat;
  position: absolute;
  left: 50%;
  margin-left: -155px;
  bottom: 30px;
  width: 309px;
  height: 115px;
  display: none;
`;

const MoreCard = styled.div`
  font-size: 50px;
  background-color: #fff;
  border-radius: 50px;
  padding: 20px 40px;
  position: absolute;
  color: #000;
  left: 50%;
  top: 220px;
  box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.3);
  transform: translateX(-50%);
  opacity: 0;
`;

const fCount = atom([]);
const cards_ = atom([]);
const score_ = atom(0);
let hintTimer = null;
let isCardGameTimeOver = false;
const GameCard = ({ data, endClick }) => {
  const [isComplete, setComplete] = useState(false);
  const [isStart, setStart] = useState(false);
  const [curWord, setWord] = useState("");
  const [cards, setCards] = useAtom(cards_);
  const [flipCount, setFlipCount] = useAtom(fCount);
  const [score, setScore] = useAtom(score_);
  const wordRef = useRef(null);

  const allBackCards = () => {
    const a = [...cards];
    setCards(
      a.map((d) => {
        return {
          ...d,
          isFlipped: true,
        };
      })
    );
  };

  const timeOver = () => {
    isCardGameTimeOver = true;
    anime.running.forEach((el) => anime.remove(el));
    anime({
      targets: ".complete-with-hidden",
      easing: "linear",
      duration: 200,
      opacity: 0,
    });

    anime({
      targets: "#moreCardGo",
      opacity: 0,
      easing: "linear",
      duration: 200,
    });

    onResetHint(true);
    // anime.remove(".cards");
    blockTouch();
    (async () => {
      await sleep(500);
      anime.remove(wordRef.current);
      anime({
        targets: wordRef.current,
        opacity: 0,
        easing: "linear",
        duration: 100,
      });
      setFlipCount([]);
      setComplete(true);
      // anime({
      //   targets: ".cards",
      //   opacity: 0,
      //   easing: "linear",
      //   duration: 200,
      // });
    })();
  };

  const onShowHint = async () => {
    blockTouch();
    const orgData = cloneDeep(cards);
    const hintData = [...cards];
    setCards(
      hintData.map((d) => {
        return {
          ...d,
          isFlipped: false,
        };
      })
    );
    await sleep(2000);
    if (isCardGameTimeOver) return;
    onResetHint();
    setCards(orgData);
    await sleep(600);
    blockTouch(false);
  };

  const onResetHint = (isOut = false) => {
    if (!document.querySelector("#hintButton")) return;
    document.querySelector("#hintButton").style.display = "none";
    if (hintTimer) {
      clearTimeout(hintTimer);
      hintTimer = null;
    }
    if (isOut) return;
    hintTimer = setTimeout(() => {
      anime({
        targets: "#hintButton",
        opacity: [0, 1],
        scale: [0.5, 1],
        easing: "easeOutBack",
        duration: 500,
        begin: () => {
          document.querySelector("#hintButton").style.display = "block";
        },
      });
    }, 7000);
  };

  useEffect(() => {
    if (isStart) {
      isCardGameTimeOver = false;
      anime({
        targets: ".complete-with-hidden",
        easing: "linear",
        opacity: 1,
        duration: 200,
      });
      anime({
        targets: "#moreCardGo",
        opacity: 0,
        easing: "linear",
        duration: 200,
      });
      const isIDO = data.categoryKey === "c8";
      const sourceData = cloneDeep(
        randomSort(isIDO === true ? data.data.resources2 : data.data.resources)
      ).slice(0, 4);
      const cardData = randomSort([...sourceData, ...sourceData]);

      setCards(
        cardData.map((d) => {
          return {
            ...d,
            isFlipped: false,
            isClear: false,
          };
        })
      );

      // anime({
      //   targets: ".cards",
      //   translateY: [30, 0],
      //   translateX: ["-50%", "-50%"],
      //   opacity: [0, 1],
      // });

      (async () => {
        await sleep(2000);
        setCards(
          cardData.map((d) => {
            return {
              ...d,
              isFlipped: true,
            };
          })
        );
        onResetHint();
      })();
    } else {
      setScore(0);
      const before = [...cards];
      setCards(
        before.map((b, i) => {
          return {
            ...b,
            isClear: false,
            isFlipped: true,
          };
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStart]);

  // 최초
  useEffect(() => {
    playSound.bgm(require("@assets/sounds/bgm/card.mp3"));
    setStart(true);
    return () => {
      setCards([]);
      setFlipCount([]);
      setScore(0);
      isCardGameTimeOver = false;
      if (hintTimer) {
        clearTimeout(hintTimer);
        hintTimer = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isFlippedCards = cards.filter((d) => d.isClear === true);
    // 전체 클리어
    if (isFlippedCards.length === cards.length && isFlippedCards.length > 0) {
      (async () => {
        onResetHint(true);
        blockTouch();
        //await sleep(2400);
        await sleep(100);
        if (isCardGameTimeOver) return;
        const isIDO = data.categoryKey === "c8";
        const sourceData = cloneDeep(
          randomSort(
            isIDO === true ? data.data.resources2 : data.data.resources
          )
        ).slice(0, 4);
        const cardData = randomSort([...sourceData, ...sourceData]);

        anime({
          targets: ".cards",
          opacity: 0,
          easing: "linear",
          duration: 10,
        });

        await sleep(100);

        anime({
          targets: "#moreCardGo",
          opacity: [0, 1],
          translateY: [30, 0],
          translateX: ["-50%", "-50%"],
          duration: 400,
          easing: "easeOutBack",
        });

        setCards(
          cardData.map((d) => {
            return {
              ...d,
              isFlipped: false,
              isClear: false,
            };
          })
        );

        await sleep(200);

        anime({
          targets: ".cards",
          translateY: [30, 0],
          translateX: ["-50%", "-50%"],
          opacity: [0, 1],
        });

        await sleep(2300);
        //await sleep(100);
        if (isCardGameTimeOver) return;
        setCards(
          cardData.map((d) => {
            return {
              ...d,
              isFlipped: true,
              isClear: false,
            };
          })
        );

        //setFlipCount([]);
        await sleep(1400);
        anime({
          targets: "#moreCardGo",
          opacity: [1, 0],
          translateY: [0, 30],
          translateX: ["-50%", "-50%"],
          duration: 400,
          easing: "easeInBack",
        });
        if (isCardGameTimeOver) return;
        onResetHint();
        blockTouch(false);
      })();
    } else {
      if (flipCount.length === 2) {
        (async () => {
          blockTouch();
          await sleep(700);
          if (cards[flipCount[0]].word === cards[flipCount[1]].word) {
            setWord(cards[flipCount[1]].word);
            playSound.effect(correctSound);
            const before = [...cards];
            setScore(score + 1);
            await setCards(
              before.map((b, i) => {
                if (i === flipCount[0] || i === flipCount[1]) {
                  return {
                    ...b,
                    isClear: true,
                    isFlipped: false,
                  };
                } else {
                  return {
                    ...b,
                    isFlipped: true,
                  };
                }
              })
            );

            await sleep(100);
            if (isCardGameTimeOver) return;
            anime({
              targets: wordRef.current,
              opacity: [0, 1],
              translateY: [-50, 0],
              translateX: ["-50%", "-50%"],
              easing: "easeOutBack",
              duration: 450,
            });
            window.__timeBarPause(true);
            await playSound.word(cards[flipCount[0]].sound);
            setFlipCount([]);
            anime({
              targets: wordRef.current,
              opacity: 0,
            });
            window.__timeBarPause(false);
            await sleep(200);
            if (isCardGameTimeOver) return;
            blockTouch(false);
          } else {
            // 오답
            playSound.effect(incorrectSound);
            setFlipCount([]);
            allBackCards();
            await sleep(400);
            blockTouch(false);
          }
        })();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flipCount]);

  useEffect(() => {
    anime({
      targets: document.querySelector(".t2"),
      scale: [1.15, 1],
      opacity: [0, 1],
    });
    //playSound.word(require("@data/assets/_static/sounds/activity1.mp3"));
    return () => {
      playSound.wordStop();
    };
  }, [data]);

  //moreCardGo
  return (
    <Wrap>
      <HintButton onClick={onShowHint} type="button" id="hintButton" />
      <TimeBarWrap>
        <TimeBar
          isStart={isStart}
          total={
            data.categoryKey === "c5" ||
            data.categoryKey === "c6" ||
            data.categoryKey === "c7"
              ? 90
              : 60
          }
          onSuccess={timeOver}
          cName="card"
        />
      </TimeBarWrap>

      <CardGameScore score={score} />
      <CardContainer className={`g-${cards.length} cards complete-with-hidden`}>
        {cards.map((card, i) => {
          return (
            <ReactCardFlip
              key={i}
              infinite={false}
              isFlipped={card.isClear ? false : card.isFlipped}
              flipSpeedBackToFront={0.6}
              flipSpeedFrontToBack={0.6}
              containerClassName={card.isClear === true && "ok"}
            >
              <Card>
                <div className="img">
                  <img src={card.img} alt="" />
                </div>
              </Card>
              <Card
                className="back"
                onClick={async () => {
                  playSound.effect(touchSound);
                  const beforeCount = [...flipCount];
                  if (beforeCount.indexOf(i) === -1) {
                    const a = [...cards];
                    a[i].isFlipped = false;
                    beforeCount.push(i);
                    setFlipCount(beforeCount);
                    setCards(a);
                  }
                }}
              ></Card>
            </ReactCardFlip>
          );
        })}
      </CardContainer>
      <CardGameWord
        word={curWord}
        refs={wordRef}
        className="complete-with-hidden"
      />
      <MoreCard id="moreCardGo">다른 카드를 뒤집어 볼까!</MoreCard>
      {isComplete && (
        <GameCompletePop
          score={score}
          onRestartClick={() => {
            setComplete(false);
            setStart(false);
            sleep(1000).then(() => {
              setStart(true);
            });
          }}
          onEndClick={endClick}
        />
      )}
    </Wrap>
  );
};

export default GameCard;
